import { type ComponentType, type CSSProperties, type FC, type ReactNode } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

export const analyticsCardClassName =
	"min-w-0 rounded-3xl border border-component-border bg-component-background p-4 sm:p-6"

type AnalyticsCardProps = {
	children: ReactNode
	className?: string
	gridArea?: string
}
export const AnalyticsCard: FC<AnalyticsCardProps> = ({ children, className, gridArea }) => {
	const style = gridArea !== undefined ? ({ gridArea } satisfies CSSProperties) : undefined

	return (
		<div className={cn(analyticsCardClassName, className)} style={style}>
			{children}
		</div>
	)
}

type AnalyticsCardHeaderProps = {
	Icon: ComponentType<{ className?: string }>
	title: string
	children?: ReactNode
}
export const AnalyticsCardHeader: FC<AnalyticsCardHeaderProps> = ({ Icon, title, children }) => (
	<div className="flex flex-wrap items-center justify-between gap-3">
		<div className="flex min-w-0 items-center gap-3">
			<div className="bg-primary/10 text-primary flex size-10 shrink-0 items-center justify-center rounded-lg">
				<Icon className="size-5 shrink-0" />
			</div>
			<h2 className="min-w-0 text-sm font-semibold">{title}</h2>
		</div>
		{children}
	</div>
)
